<template>
  <Modal>
    <div :style="styles.modalHeader">
      <h3 :style="styles.modalTitle">Add Sequence To Policy</h3>
    </div>
      <LibraryGrid
        v-if="checkCardsLoaded && getSequences"
        :baseStyle="{paddingTop: 0}"
        fullWidth
      >
          <section
            class="cardWrap"
            v-for="sequence in getSequences"
            :key="sequence.name"
            :style="styles.cardWrap"
            @click="setSelectedSequence(sequence)"
          >
            <div :style="styles.cardContainer"
            >
              <p
                :style="styles.cardName"
              >
                Sequence
            </p>
              <p>
               {{sequence.name}}
              </p>
            </div>
            <i
              :style="styles.backIcon"
              class="glyphicon glyphicon-chevron-right"
            ></i>
          </section>
      </LibraryGrid>
  </Modal>
</template>
<script>
import Modal from '../general/Modal';
import LibraryGrid from '../general/LibraryGrid';
import CloseIcon from 'vue-material-design-icons/Close';
import Services from '../../services/Services';
import store from '../../store';
export default {
  name: 'AddSequenceToPolicyModal',
  components: {
    LibraryGrid,
    Modal
  },
  computed: {
    checkCardsLoaded() {
      return store.getters.checkCardsReady;
    },
    getSequences() {
      return store.getters.getSequences;
    }
  },
  methods: {
    setSelectedSequence(sequence) {
      let activePolicy = store.getters.getActivePolicy;
      activePolicy.sequence = sequence._id;
      store.commit('setActivePolicy', activePolicy);
      store.commit('setSelectedSequence', sequence);
      store.commit('hideModals', true);
    }
  },
  data() {
    return {
      hideModal: Services.hideModals,
      cardsLoaded: false,
      styles: {
        mediaGrid: confirmationScreen => ({
          display: confirmationScreen ? 'none' : 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap'
        }),
        modal: {
          background: '#fff',
          width: '90vw',
          height: '90vh',
          maxHeight: '90vh',
          margin: '0 auto',
          padding: '2rem 2rem 4rem',
          overflowY: 'scroll',
          overflowX: 'hidden',
          position: 'relative'
        },
        mediaContainer: {
          margin: 'auto',
          width: '100%',
          maxWidth: '500px'
        },
        confirmationBase: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        },
        buttonContainer: {
          display: 'flex',
          margin: 'auto',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          width: '235px'
        },
        confirmationButtons: {
          display: 'block',
          width: '49%'
        },
        modalHeader: {
          boxSizing: 'border-box',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #444',
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: '10px',
          marginRight: '30px'
        },
        removeButton: {
          background: '#eb4d4b',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px',
          margin: 'auto 0 auto 10px',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        },
        cancelButton: {
          background: '#888'
        },
        modalTitle: {
          color: '#444',
          fontSize: '1.5rem'
        },
        modalGridContainer: {
          overflow: 'scroll'
        },
        closeIcon: {
          position: 'fixed',
          top: '10px',
          right: '10px',
          fontSize: '2em',
          color: '#ddd',
          cursor: 'pointer'
        },
        yesButton: {
          background: '#6ab04c'
        },
        goBackLink: {
          color: 'rgb(9, 163, 237)',
          cursor: 'pointer',
          marginTop: '2rem',
          ':hover': {
            opacity: '0.9'
          }
        },
        backIcon: {
          position: 'relative',
          top: '23px'
        },
        cardWrap: {
          background: '#fff',
          display: 'flex',
          padding: '10px',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          width: 'calc(33.33% - 20px)',
          // margin: '10px',
          ':hover': {
            border: '1px solid #888',
            cursor: 'pointer'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40px',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        }
      }
    };
  },
  mounted() {
    Services.getSequences();
  }
};
</script>
<style lang="scss" scoped>
p {
  margin: 10px 0;
}
.cardWrap {
  background: #fff;
  display: flex;
  border: 1px solid #eee;
  padding: 10px;
  box-sizing: border-box;
  flex-flow: row nowrap;
  width: calc(33.33% - 20px);
  margin: 10px;
  transition: all 0.2s;
  &:hover {
    border: 1px solid #888;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AddSequenceToPolicy.vue